import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62d7e16f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "plusMetrics-header",
  class: "padding-left-15 line-height-25"
}
const _hoisted_2 = { class: "Plus" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "PLUS(PPD)", -1))
const _hoisted_4 = {
  class: "actionable-plusmetrics",
  id: "actionable-plusmetrics"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "target census-data",
  id: "pmTarget"
}, "Target: ", -1))
const _hoisted_6 = { class: "digits plusMetrics text-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "actual census-data",
  id: "pmActual"
}, "Actual: ", -1))
const _hoisted_8 = { class: "digits plusMetrics text-end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "variance census-data",
  id: "pmVariance"
}, "Difference: ", -1))
const _hoisted_10 = {
  key: 0,
  class: "mr-1"
}
const _hoisted_11 = {
  key: 1,
  class: "mr-1"
}
const _hoisted_12 = { class: "digits plusMetrics text-end" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "actual census-data",
  id: "pmProdIndex"
}, "Prod. Index: ", -1))
const _hoisted_14 = { class: "digits plusMetrics text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_neu_col = _resolveComponent("neu-col")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_neu_row, { class: "row white-background-color" }, {
      default: _withCtx(() => [
        _createVNode(_component_neu_col, {
          xxl: "3",
          xl: "6",
          lg: "12",
          md: "3",
          sm: "6",
          cols: "12",
          class: "text-start-padding"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_component_neu_icon, {
                color: "primary",
                onClick: _ctx.openTrainingDocument,
                style: {"cursor":"pointer","color":"#3673AA"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("info")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createTextVNode(),
              _hoisted_3
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_neu_col, {
          xxl: "3",
          xl: "6",
          lg: "12",
          md: "3",
          sm: "6",
          cols: "12",
          class: "text-end-padding"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("a", {
                class: "actionable-menu-link viewMore",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showMetricsView && _ctx.showMetricsView(...args)))
              }, "View More")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_neu_row, { class: "row white-background-color" }, {
      default: _withCtx(() => [
        _createVNode(_component_neu_col, {
          xxl: "3",
          xl: "6",
          lg: "12",
          md: "3",
          sm: "6",
          cols: "12",
          class: "text-start"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_neu_col, {
          xxl: "3",
          xl: "6",
          lg: "12",
          md: "3",
          sm: "6",
          cols: "12",
          class: "text-end"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.TargetHours), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_neu_row, { class: "row white-background-color" }, {
      default: _withCtx(() => [
        _createVNode(_component_neu_col, {
          xxl: "3",
          xl: "6",
          lg: "12",
          md: "3",
          sm: "6",
          cols: "12",
          class: "text-start"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_neu_col, {
          xxl: "3",
          xl: "6",
          lg: "12",
          md: "3",
          sm: "6",
          cols: "12",
          class: "text-end"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.ActualHours), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_neu_row, { class: "row white-background-color" }, {
      default: _withCtx(() => [
        _createVNode(_component_neu_col, {
          xxl: "3",
          xl: "6",
          lg: "12",
          md: "3",
          sm: "6",
          cols: "12",
          class: "text-start"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_neu_col, {
          xxl: "3",
          xl: "6",
          lg: "12",
          md: "3",
          sm: "6",
          cols: "12",
          class: "text-end pl-0",
          id: "variance-details"
        }, {
          default: _withCtx(() => [
            (_ctx.VarianceNegative)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'arrow-circle-down'],
                    size: "sm"
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.VariancePositive)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'arrow-circle-up'],
                    size: "sm"
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.VarianceHours), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_neu_row, { class: "row white-background-color" }, {
      default: _withCtx(() => [
        _createVNode(_component_neu_col, {
          xxl: "3",
          xl: "6",
          lg: "12",
          md: "3",
          sm: "6",
          cols: "12",
          class: "text-start"
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_neu_col, {
          xxl: "3",
          xl: "6",
          lg: "12",
          md: "3",
          sm: "6",
          cols: "12",
          class: "text-end"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.ProdIndex), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}